package fr.manyverse.app.domain.util

/**
 * Nom lisible tiré d'un nom de fichier : chemin et extension retirés, tirets et underscores
 * remplacés par des espaces, première lettre en majuscule (le reste est conservé).
 * Ex. `auberge-de_silltown.mp3` → `Auberge de silltown`.
 */
fun String.toDisplayNameFromFileName(): String {
    val baseName = substringAfterLast('/')
    return baseName.substringBeforeLast('.', baseName)
        .replace('-', ' ')
        .replace('_', ' ')
        .split(' ')
        .filter { it.isNotBlank() }
        .joinToString(" ")
        .replaceFirstChar { it.uppercase() }
}
